import { renderCellWithIcon } from '../dropdowns/dropdown-in-excel';

import type { RendererFunction } from '../../common/handsontable.types';

/**
 * Custom renderer for autocomplete columns to show dropdown icon
 * Used in Handsontable to display autocomplete cells with a visual indicator
 * @param cellProperties - Cell properties from cells function (contains className)
 */
export const autocompleteRenderer: RendererFunction = (
  _instance,
  td,
  _row,
  _col,
  _prop,
  value,
  cellProperties
) => {
  return renderCellWithIcon(td, value, cellProperties);
};
